import Basic1 from './Basic1'
export default Basic1
